module.exports = __webpack_public_path__ + "static/media/principal-banner.e9439dc0.png";